// src/components/ProfileSidebar.tsx

import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { instance } from '../api/axiosInstance';
import { UserContext } from './UserContext'; // 올바른 경로 확인

export default function ProfileSidebar() {
  const { user } = useContext(UserContext); // UserContext 사용
  const [formattedCreatedAt, setFormattedCreatedAt] =
    useState<string>('가입 시기 정보 없음');

  useEffect(() => {
    if (user && user.createdAt) {
      const date = new Date(user.createdAt);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
      const day = String(date.getDate()).padStart(2, '0');
      setFormattedCreatedAt(`${year}년 ${month}월 ${day}일`);
    } else {
      setFormattedCreatedAt('가입 시기 정보 없음');
    }
  }, [user]);

  // 기본 프로필 이미지 설정 및 캐싱 방지
  const profileImageSrc = user?.profileImageUrl
    ? `${instance.defaults.baseURL}${
        user.profileImageUrl
      }?t=${new Date().getTime()}` // 캐싱 방지
    : '/favicon.png';

  return (
    <div className="mt-[50px] pb-[40px] min-w-[240px] min-h-[500px] h-full bg-darkGray text-white border rounded-[15px] shadow-md">
      <div className="mt-[25px] flex items-center flex-col p-4">
        <div className="w-20 h-20 bg-transparent mb-2 overflow-hidden">
          <img
            src={profileImageSrc}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        </div>
        <p className="text-black text-[11px] font-normal tracking-wide mb-[14px]">
          프로필 설정
        </p>
        <p className="text-black text-lg font-bold tracking-wide text-[20px] mb-[5px]">
          {user?.nickname || 'Unknown User'}
        </p>
        <p className="text-black/55 text-[12px] font-normal tracking-wide">
          가입 시기 &nbsp;|&nbsp; {formattedCreatedAt}
        </p>
      </div>
      <ul className="text-sm leading-5 overflow-auto overflow-x-hidden text-left w-full">
        <li className="h-[45px]">
          <NavLink
            to="/setting/setting"
            className={({ isActive }) =>
              isActive
                ? 'flex items-center justify-center w-full h-full bg-lightGray text-black font-semibold'
                : 'flex items-center justify-center w-full h-full text-black hover:text-[#04E1CF]'
            }
          >
            내 정보
          </NavLink>
        </li>
        <li className="h-[45px]">
          <NavLink
            to="/setting/account"
            className={({ isActive }) =>
              isActive
                ? 'flex items-center justify-center w-full h-full bg-lightGray text-black font-semibold'
                : 'flex items-center justify-center w-full h-full text-black hover:text-[#04E1CF]'
            }
          >
            계정
          </NavLink>
        </li>
        <li className="h-[45px]">
          <NavLink
            to="/setting/sns"
            className={({ isActive }) =>
              isActive
                ? 'flex items-center justify-center w-full h-full bg-lightGray text-black font-semibold'
                : 'flex items-center justify-center w-full h-full text-black hover:text-[#04E1CF]'
            }
          >
            SNS 주소
          </NavLink>
        </li>
        <li className="h-[45px]">
          <NavLink
            to="/setting/coupon"
            className={({ isActive }) =>
              isActive
                ? 'flex items-center justify-center w-full h-full bg-lightGray text-black font-semibold'
                : 'flex items-center justify-center w-full h-full text-black hover:text-[#04E1CF]'
            }
          >
            쿠폰
          </NavLink>
        </li>
        <li className="h-[45px]">
          <NavLink
            to="/setting/newslatter"
            className={({ isActive }) =>
              isActive
                ? 'flex items-center justify-center w-full h-full bg-lightGray text-black font-semibold'
                : 'flex items-center justify-center w-full h-full text-black hover:text-[#04E1CF]'
            }
          >
            뉴스레터
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
